/*eslint-disable */

import { bus } from '@/main';
import {
  mapGetters,
} from 'vuex';
import toast from '@/services/toast';

export default {
  name: 'global-notification-page',
  components: {},
  props: [],
  data () {
    return {
      getGlobalNotificationData:null,
      getGlobalNotificationDataResults:[],
      isReadState:false
    }
  },
  computed: {
  },
  mounted () {
    bus.$emit('clearNotificationBadgeInfo', null);
  },
  methods: {
    readNotificationByIdmethod(itemId){
      let data = {
        id : itemId,
        is_read: 'True'
      }
      this.$store.dispatch('readNotificationByIdAction', data).then((res) => {
        this.$store.dispatch('getGlobalNotificationMethod',  {flag:'False'})
        toast.success('Notification is marked as read!');
      })
    },
    isReadChangeMethod(){
      if(this.isReadState){
        this.$store.dispatch('getGlobalNotificationMethod', {flag:'False'})
      }else{
        this.$store.dispatch('getGlobalNotificationMethod', {flag:'True'})
      }
    },
    readAllNotificationMethod(){
      this.$store.dispatch('patchGlobalNotificationReadMethod').then((res) => {
        this.$store.dispatch('getGlobalNotificationMethod',  {flag:'False'})
        toast.success(res.data);
      }).catch((err) => {
        toast.error(err.data.msg);
      })
    }
  },
  watch: {
  },
}